var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#f4f6f5"}},[_c('PCNavbar',{attrs:{"selectIndex":"8"}}),_c('MobileNavBar',{attrs:{"currentActive":0}}),_c('shopDetail',{attrs:{"id":_vm.id}}),_c('CallMe'),_c('MobileCallme')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }